<template>
    <div class="t_content_view">
        <div class="t_search_box">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">企微主体：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.corp_id" @change="changezt" clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select">
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="changeinput" size="small" v-model="searchdata.name" placeholder="请输入渠道活码名称"  clearable />
            </div>
            <!-- <div class="t_search_select">
                <span style="color: #6D6D6D;">使用渠道：</span>
                <el-select value-key="id"
                @change="qdchange"
                style="width: 180px;"
                size="small" v-model="searchdata.channel_ids" clearable placeholder="请选择">
                    <el-option v-for="(item,index) in allqdlist.data" 
                    :key="index"
                    :label="item.title" 
                    :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">使用成员：</span>
                <el-cascader
                    style="width: 300px;"
                    v-model="searchdata.member_ids"
                    :options="allcomppeolist.data"
                    :props="{ expandTrigger: 'hover' }"
                    placeholder="请选择成员"
                    clearable
                    @change="cychange"
                    />
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">状态：</span>
                <el-select size="small"
                @change="ztchange"
                style="width: 180px;"
                v-model="searchdata.status" clearable placeholder="请选择">
                    <el-option  :key="1" label="使用中" :value="1" />
                </el-select>
            </div> -->
            <el-button @click="resetsearch" color="#F1F3F9" style="margin-bottom: 10px;" type="primary">重置</el-button>
        </div>
        <router-link :to="{path:'/navtkyl/newaddlink'}">
            <el-button color="#4F46E5" class="t_add_people" type="primary" >新增专属加人码</el-button>
        </router-link>
        
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%">
            <el-table-column prop="name" label="加人码名称">

            </el-table-column>
            <el-table-column prop="qrcode_url" label="加人码链接">
                <template #default="scope">
                    <div>{{scope.row.custom_url}}</div>
                    <el-button @click="copy(scope.row.custom_url)" size="small" type="text" 
                        style="color:#4F46E5"
                        >复制</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="channel_id" label="所属渠道">
                <template #default="scope">

                    <span v-if="scope.row.channel">{{scope.row.channel.title}}</span>
                    <span v-else>无</span>

                </template>
            </el-table-column>
            <el-table-column prop="member_ids" label="当前使用成员">
                <template #default="scope">

                    <img v-if="scope.row.members.length < 6" v-for="(item, index) in scope.row.members" :key="index"
                        style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                        :src="item.member_avatar" alt="">
                    <div class="t_more_img" v-else>
                        <img v-for="(item, index2) in scope.row.members.slice(0, 5)" :key="index2"
                            style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                            :src="item.member_avatar" alt="">
                        <div class="t_more">{{ scope.row.members.length }}</div>
                    </div>


                </template>
            </el-table-column>
            <el-table-column prop="friend_count" label="添加客户数" />
            <el-table-column prop="created_at" label="创建时间" />
            <el-table-column prop="status" label="状态" >
                <template #default="scope">
                    <span v-if="scope.row.status==1">使用中</span>
                    <span v-else>已失效</span>
                </template>
            </el-table-column>
            
            <el-table-column label="操作">
                <template #default="scope">
                    <!-- <el-button size="small" type="text" 
                    style="color:#4F46E5"
                    @click="downloadByBlob( scope.row.qrcode_url)">下载</el-button> -->
                    <router-link :to="{path:'/navtkyl/newaddlink',query:{id:scope.row.id}}">
                        <el-button size="small" type="text" 
                        style="color:#4F46E5"
                        >编辑</el-button>
                    </router-link>
                    <router-link :to="{path:'/navtkyl/linkdata',query:{id:scope.row.id}}">
                        <el-button size="small" type="text" 
                        style="color:#4F46E5"
                        >查看数据</el-button>
                    </router-link>
                    <el-button @click="delbtn(scope.row.id)" size="small" type="text" 
                        style="color:#4F46E5"
                        >删除</el-button>
                    <!-- <el-dropdown 
                    @command="handleCommand"
                    class="example-showcase">
                        <span 
                         style="color:#4F46E5"
                         class="el-dropdown-link">
                            更多
                            <el-icon class="el-icon--right">
                                <arrow-down />
                            </el-icon>
                        </span>
                        <template #dropdown>
                            <el-dropdown-menu >
                                <el-dropdown-item :command="beforeHandleCommand(scope.row.id,'b')">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown> -->
                </template>
            </el-table-column>
        </el-table>
         <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>
   <!-- 释放弹窗 -->
   <el-dialog
    v-model="sfwindow"
    title="释放渠道活码"
    width="500px"
  >
    <div style="text-align:center">释放渠道活码【企业微信先咨询-后加好友】</div>
    <div style="text-align:center;color:#FF2E0E;margin-top: 20px;margin-bottom:20px;">释放后不可恢复，请谨慎操作！</div>
    
    <div class="t_cz_box">
        <el-button  @click="sfwindow = false">取消</el-button>
        <el-button color="#4F46E5"  type="primary" @click="sfwindow = false"
          >确认释放</el-button>
    </div> 
  </el-dialog>
  <!-- 查看活码 -->
  <el-dialog
    v-model="hmwindow"
    title="查看"
    width="300px"
  >
    <div style="text-align:center">
        <img style="width:100%" :src="nowhmsrc" alt="">
    </div>
  </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch,inject } from 'vue'
import { ElMessage,ElMessageBox, ArrowDown } from 'element-plus'
import { qdhmlist,delqdhm,qdmlist,newgethmqdlist,newgethmcylist,newgethmlist,newgethmdel,newgetcomppeo,newgetcomp2 } from '@/assets/js/common.js'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { variableDeclarator } from '@babel/types';
import { useRoute, useRouter } from 'vue-router'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    //获取列表
    getlist()
    //获取所有成员下拉
    getallpeolist()
    //获取所有渠道下拉
    getallqdlist()
    //获取主体+成员
    getcomppeolist()
    //获取企微主体下拉
    getcorplist()
})
//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}

//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    newgethmcylist({page:1,page_size:20000}).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log('成员')
            console.log(response.data.data.data)
            allpeolist.data = response.data.data.data
        }
    })
}
//所有渠道下拉
const allqdlist = reactive({
    data:[]
})
//获取所有渠道下拉
const getallqdlist = ()=>{
    newgethmqdlist({ page:1,
    page_size:200000,
    channel_title:'',
    channel_type_id:''}).then((response)=>{
        if (response.data.msg.code == 0) {
            // console.log(response.data.result)
            allqdlist.data = response.data.data.data
        }
    })
}

//列表数据
const tableData = reactive({
    data:[]
})
//成员总数
const total = ref(0)
//搜索
const searchdata = reactive({
   //当前页
    page:1,
    page_size:20,
    name:'',
    channel_ids:'',
    member_ids:'',
    status:'',
    corp_id:'',
    class:2
})
//搜索活码名称变化
const changeinput = (val)=>{
    console.log(val)
    searchdata.name = val
    searchdata.page = 1
    getlist()

}
//企微主体下拉变化
const changezt = (val)=>{
    console.log(val)
    searchdata.corp_id = val
    searchdata.page = 1
    getlist()

}
//使用渠道下拉变化
const qdchange = (val)=>{
    console.log(val)
    searchdata.channel_ids = val
    searchdata.page = 1
    getlist()
}
//成员下拉变化
const cychange = (val)=>{
    console.log(val)
    searchdata.member_ids = val[1]
    searchdata.page = 1
    getlist()
}
//状态下拉变化
const ztchange = (val)=>{
    console.log(val)
    searchdata.status = val
    searchdata.page = 1
    getlist()
}
//重置
const resetsearch = ()=>{
    searchdata.page=1
    searchdata.name='',
    searchdata.channel_ids='',
    searchdata.member_ids='',
    searchdata.status='',
    searchdata.corp_id=''
    getlist()
}
//获取列表
const getlist = ()=>{
    newgethmlist(searchdata).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log(response.data)
            tableData.data = response.data.data.data
            // for(var i =0;i<tableData.data.length;i++){
                // tableData.data[i].member_ids=tableData.data[i].member_ids.split(',')
            // }
            total.value = response.data.data.total
        }
    })
}
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}
//查看活码弹窗
const hmwindow = ref(false)
//当前查看活码链接
const nowhmsrc = ref('')
//点击查看活码
const checkhm = (url)=>{
    hmwindow.value=true
    nowhmsrc.value = url
}




//复制短链
const copy = (val) => {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.setAttribute('value', val);
    input.select();
    if (document.execCommand('copy')) {
        document.execCommand('copy');
        ElMessage({
            message: '复制成功',
            type: 'success',
        })
    }
    document.body.removeChild(input);
}
//下载活码
const downloadByBlob = (url)=>{
    let image = new Image()
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = url
    image.onload = () => {
      let canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0, image.width, image.height)
      canvas.toBlob((blob) => {
        let url = URL.createObjectURL(blob)
        download(url,'活码')
        // 用完释放URL对象
        URL.revokeObjectURL(url)
      })
    }
}
const download = (href, name)=>{
  let eleLink = document.createElement('a')
  eleLink.download = name
  eleLink.href = href
  eleLink.click()
  eleLink.remove()
}
const beforeHandleCommand = (id,command)=>{
    return {
        'id': id,
        'command':command
    }
}
//更多
const handleCommand = (command)=>{
    console.log(command)
    if(command.command=='a'){
        sfwindow.value = true
    }else if(command.command=='b'){
        ElMessageBox.confirm(
            '是否确认删除?',
            '提示',
            {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            }
        ).then(() => {
            newgethmdel({ids:command.id}).then((response)=>{
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '删除成功！',
                    })
                    getlist()
                }
            })
            
        }).catch(() => {
            ElMessage({
                type: 'info',
                message: '已取消',
            })
        })
    }else if(command.command=='c'){
        router.push({ path: '/navtkyl/createhm',query:{id:command.id} })
    }
}

//删除
const delbtn = (id)=>{
    ElMessageBox.confirm(
            '是否确认删除?',
            '提示',
            {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            }
        ).then(() => {
            newgethmdel({ids:id}).then((response)=>{
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '删除成功！',
                    })
                    getlist()
                }
            })
            
        }).catch(() => {
            ElMessage({
                type: 'info',
                message: '已取消',
            })
        })
}



//释放弹窗
const sfwindow = ref(false)

//获取主体+成员下拉
const allcomppeolist = reactive({
    data:[]
})
//获取主体+成员下拉
const getcomppeolist = ()=>{
    newgetcomppeo().then((response)=>{
        if (response.data.msg.code == 0) {
            
            allcomppeolist.data = response.data.data.map(corp => {
                const hasDevices = corp.device && corp.device.length > 0;
                return {
                value: corp.corp_id,
                label: corp.corp_name,
                // 无设备时禁用该项并清空 children
                disabled: !hasDevices,
                children: hasDevices
                    ? corp.device.map(device => ({
                        value: device.id,
                        label: device.name,
                        // 可添加其他自定义属性，如在线状态图标等
                        // 此处保留原始设备对象以便扩展
                        rawDevice: device
                    }))
                    : []
                };
            });
           console.log('主体+成员')
            console.log(allcomppeolist.data)
        }
    })
}

//主体+成员下拉选中的数据
const selectedPath = reactive({
    data:[]
})
//联动数据
const handleChange = (val)=>{
    console.log(val)
}
</script>
<style scoped>


:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_box .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
.el-dropdown-menu{
    background-color: rgba(0, 0, 0, 0.8);
    
}
:deep(.el-dropdown-menu__item) {
    color:white !important
}
:deep( .el-dropdown-menu__item:not(.is-disabled):focus ){
        background-color: black;
        color: white;
    }

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}

.t_head_box {
    display: flex;
    align-items: center;
}

/* .t_content_view {
    padding: 20px;
} */

/* .t_cz_box {
    display: flex;
    justify-content:space-around
} */

.t_all_tag {
    margin-top: 10px;
    margin-right: 10px;
}

.t_tagchoose_box {
    margin-bottom: 30px
}

.t_more_img {
    display: flex;
    flex-wrap: wrap;
}

.t_more {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    border: 1px solid white;
    border-radius: 50%;
    background-color: rgb(206, 206, 206);
    text-align: center;
    line-height: 30px;
}

.example-showcase .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: bold;
    padding: 7px 11px;
}
</style>